import { render, staticRenderFns } from "./InquiryIndex.vue?vue&type=template&id=38c000e1&scoped=true"
import script from "./InquiryIndex.vue?vue&type=script&lang=js"
export * from "./InquiryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c000e1",
  null
  
)

export default component.exports